<template>
  <section>
    <login-form
      @redirect-to="view => tab = view"
      @authenticated="handleUserAuthenticated()"
      v-if="isActiveTab('login')"
    />

    <register-form
      @redirect-to="view => tab = view"
      @authenticated="handleUserAuthenticated()"
      v-else-if="isActiveTab('register')"
    />

    <forgot-password-form
      @redirect-to="view => tab = view"
      v-else-if="isActiveTab('forgot-password')"
    />
  </section>
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useLanguageStore } from '@/stores/LanguageStore'
import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import { storeToRefs } from 'pinia'

const LoginForm = defineAsyncComponent(() => import('&/modules/sessions/LoginForm'))
const RegisterForm = defineAsyncComponent(() => import('&/modules/sessions/RegisterForm'))
const ForgotPasswordForm = defineAsyncComponent(() => import('&/modules/sessions/ForgotPasswordForm'))

const emit = defineEmits(['authenticated', 'close'])

const { tab: defaultTab } = defineProps({
  tab: { type: String, default: 'register' }
})

const { replace } = useRouter()
const { params, query } = useRoute()
const { locale } = storeToRefs(useLanguageStore())
const { initAuthentication } = useAuthenticationStore()

const tab = ref(defaultTab)

const isActiveTab = value => tab.value === value

const handleUserAuthenticated = () => {
  initAuthentication()
    .then(() => {
      if (params.locale !== locale.value) replace({ params: { locale: locale.value }, query })
    })
    .finally(() => emit('authenticated'))
}
</script>
